import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { panelStyle } from './DashboardPanel';
import { PRIMARY } from '../../components/LmsSectionCard';
import { useLmsPermission } from '../../hooks/useLmsPermission';
import { LMS, LMS_ANY_VIEW } from '../../../../constants/permissionCodes';

const ACTIONS = [
    { key: 'catalog', icon: 'pi-book', to: '/learning-management-system/training-catalog', codes: [LMS.TRAINING_VIEW] },
    { key: 'planning', icon: 'pi-calendar-plus', to: '/learning-management-system/training-planning', codes: [LMS.TRAINING_VIEW] },
    { key: 'report', icon: 'pi-chart-bar', to: '/learning-management-system/training-report', codes: [LMS.REPORT_VIEW] },
    { key: 'videos', icon: 'pi-video', to: '/learning-management-system/library/videos', codes: LMS_ANY_VIEW }
];

const QuickActions = () => {
    const { th } = useLanguage();
    const { can } = useLmsPermission();
    const actions = ACTIONS.filter((action) => can(action.codes));

    return (
        <div className="grid m-0" style={{ gap: 0 }}>
            {actions.map((action, index) => (
                <div key={action.key} className="col-6 p-0" style={{ paddingRight: index % 2 === 0 ? '0.5rem' : 0, paddingLeft: index % 2 === 1 ? '0.5rem' : 0, paddingBottom: index < 2 ? '1rem' : 0 }}>
                    <Link to={action.to} className="lms-dashboard-action no-underline h-full flex flex-column align-items-center text-center gap-2 p-3" style={panelStyle}>
                        <i className={`pi ${action.icon}`} style={{ fontSize: '1.75rem', color: PRIMARY }} />
                        <span className="font-bold text-sm" style={{ color: '#101828', textTransform: 'uppercase' }}>
                            {th(`lmsDashboard.quickActions.${action.key}`)}
                        </span>
                        <span className="text-xs" style={{ color: '#475467' }}>
                            {th(`lmsDashboard.quickActions.${action.key}Desc`)}
                        </span>
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default QuickActions;
